import Dashboard from "../../components/Admin/DashboardMain";

export default function Admin() {
  return (
      <Dashboard />
  );
}
